// extracted by mini-css-extract-plugin
module.exports = {"successMassage":"style_successMassage__19Ak0","successMessageWtapper":"style_successMessageWtapper__3pay7"};